import { useEffect, useState } from "react";
import firebase from "../../firebase/config";

const PrivacyPolicy = () => {
  const [description, setDescription] = useState("");
  const [lastUpdatedDate, setLastUpdatedDate] = useState("");

  const [error, setError] = useState("");

  useEffect(() => {
    const fetchPrivacyPolicy = async () => {
      try {
        const db = firebase.firestore();
        const doc = await db.collection("Game_Config").doc("PrivacyPolicy").get();

        if (doc.exists) {
          setDescription(doc.data()?.Description || "");
          setLastUpdatedDate(doc.data()?.updatedAt || "")
          console.log("privacy policy data",doc.data())
        } else {
          setError("No privacy policy data available.");
        }
      } catch (err) {
        setError("Error fetching privacy policy data.");
        console.error(err);
      }
    };

    fetchPrivacyPolicy();
  }, []);

  return <>
    <div className="p-3">
      <h1>Privacy Policy</h1>
        Last Updated on (YYYY-MM-DD) : {lastUpdatedDate}
        <p style={{ whiteSpace: "pre-wrap"}}>{description}</p>
      
    </div>
  </>
};

export default PrivacyPolicy;

